// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ssh_content[data-v-e20297a2]{padding:20px;background-color:var(--el-color-primary-light-9)}", ""]);
// Exports
module.exports = exports;
